import { InfiniteStatusEnum } from '../../../repository/infinite'

const FOOTER_VISUAL = '/images/infinite/footer_visual.png'

type InfiniteLandingTrustStatementProps = {
  onboardingStatus?: InfiniteStatusEnum
}

export const InfiniteLandingTrustStatement = ({ onboardingStatus }: InfiniteLandingTrustStatementProps) => {
  return (
    <div className='bg-white pt-[46px] text-center'>
      <p className='font-libre-caslon text-[9px] leading-[1.22] tracking-[7.38px] text-black'>LIMITED ACCESS</p>
      <h2 className='mt-[34px] font-libre-caslon text-[24px] leading-normal tracking-[-0.72px] text-black'>
        Access to Infinite is limited.
        <br />
        By design.
      </h2>
      <p className='mt-[32px] mx-auto font-libre-franklin text-[16px] font-normal leading-normal text-black max-w-[300px]'>
        We onboard a select number of portfolios to maintain depth, discipline, and attention.
      </p>
      {onboardingStatus === InfiniteStatusEnum.ELIGIBLE ||
      onboardingStatus === InfiniteStatusEnum.ELIGIBLE_WITH_CALLBACK ? (
        <p className='mt-[34px] font-libre-franklin text-[13px] font-normal text-[#7B8DA1]'>
          {onboardingStatus === InfiniteStatusEnum.ELIGIBLE_WITH_CALLBACK
            ? 'Request a callback to learn more'
            : 'Join the Waitlist to secure your spot'}
        </p>
      ) : null}
      <img src={FOOTER_VISUAL} alt='Infinite visual detail' className='mx-auto mt-2 h-[195px] w-full max-w-full object-cover object-top' />

    </div>
  )
}
